import { Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress } from "@mui/material";
import React from "react";
import { notifySomething } from "../_Utils/AppDocuCommon";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import VehicleDialogForm from "./_VehicleDialogForm";

export default class EditVehicleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      loading: false,
      prevVehicleId: null,
    };
  }

  async componentDidUpdate(prevProps) {
    if (this.props.vehicleId && this.props.vehicleId !== prevProps.vehicleId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getVehicle(this.props.vehicleId);
        const vehicle = res.data.machine || {};
        await new Promise(resolve => setTimeout(resolve, 500)); // sleep 500ms
        this.setState({ itemData: EditVehicleDialog.normalizeVehicleData(vehicle), loading: false, prevVehicleId: this.props.vehicleId });
      } catch (e) {
        this.setState({ loading: false });
        notifySomething('Errore caricamento dati macchina', 'error');
      }
    }
    // Reset state if dialog is closed
    if (!this.props.vehicleId && prevProps.vehicleId) {
      this.setState({ itemData: null, loading: false, prevVehicleId: null });
    }
  }

  static normalizeVehicleData(vehicle) {
    return {
      ...vehicle,
      power: vehicle.power !== undefined && vehicle.power !== null ? String(vehicle.power) : '0',
      cylinders: vehicle.cylinders !== undefined && vehicle.cylinders !== null ? String(vehicle.cylinders) : '4',
      displacement: vehicle.displacement !== undefined && vehicle.displacement !== null ? String(vehicle.displacement) : '0',
    };
  }

  updateVehicleService = async (itemData) => {
    try {
      const res = await AppDocuServiceCall.updateVehicle(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error updating vehicle', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error updating vehicle:', error);
      notifySomething('Error updating vehicle', 'error');
    }
  };
  
  handleUpdate = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      brand: m.brand !== undefined && m.brand !== null ? m.brand : '',
      model: m.model !== undefined && m.model !== null ? m.model : '',
      description: m.description !== undefined && m.description !== null ? m.description : '',
      engine_code: m.engine_code !== undefined && m.engine_code !== null ? m.engine_code : '',
      cylinders: m.cylinders !== undefined && m.cylinders !== null ? m.cylinders : '0',
      displacement: m.displacement !== undefined && m.displacement !== null ? m.displacement : '0',
      power: m.power !== undefined && m.power !== null ? m.power : '0',
      euro_code: m.euro_code !== undefined && m.euro_code !== null ? m.euro_code : '',
      petrol_ecu: m.petrol_ecu !== undefined && m.petrol_ecu !== null ? m.petrol_ecu : '',
      internal_notes: m.internal_notes !== undefined && m.internal_notes !== null ? m.internal_notes : '',
      user_notes: m.user_notes !== undefined && m.user_notes !== null ? m.user_notes : '',
      status: m.status !== undefined && m.status !== null ? m.status : '',
    };
    // Conversione numerica per i campi numerici
    data.power = data.power ? Number(data.power) : 0;
    data.cylinders = data.cylinders ? Number(data.cylinders) : 0;
    data.displacement = data.displacement ? Number(data.displacement) : 0;
    // Call the service to update the vehicle
    await this.updateVehicleService(data);
  }

  render() {
    const { itemData, loading } = this.state;
    return (
      <>
      {loading || !itemData ? (
        <Dialog open={!!this.props.vehicleId} onClose={this.props.onClose} maxWidth="xl" fullWidth>
          <DialogTitle>Edit Vehicle</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
              <CircularProgress size={40} thickness={4} />
            </div>
          </DialogContent>
        </Dialog>    
      ) : (
        <Dialog open={!!this.props.vehicleId} onClose={this.props.onClose} maxWidth="xl" fullWidth>
          <DialogTitle>Edit Vehicle</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <VehicleDialogForm
              itemData={itemData}
              onChange={newData => this.setState({ itemData: newData })}
              disabled={false}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose}>Cancel</Button>
            <Button onClick={this.handleUpdate} color="primary" disabled={loading || !itemData}>Update</Button>
          </DialogActions>
        </Dialog>
      )}
      </>
    );
  }
}
